/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * CampaignInfo types
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.12.0
 */

export enum ECampaignInfoType {
    account = 'account',
    subscriber = 'subscriber',
}

export enum ECampaignInfoModalStatus {
    failure = 'failure',
    processing = 'processing',
    start = 'start',
    success = 'success',
}

export enum ECampaignInfoActions {
    apply = 'APPLY_BTN',
    // true если список участников должен отображаться, false в ином случае
    participantList = 'PARTICIPANTS',
    remove = 'REMOVE_BTN',
    // Параметр, хранящий информацию об отображении элементов МП для управления МП самим участником
    // true если участник должен иметь возможность управлять МП только для себя, false в ином случае
    selfManage = 'SELF_MANAGE',
}

export interface ICampaignInfoGeneral {
    description?: string;
    id: number;
    imgUrl?: string;
    pageUrl?: string;
    text: {
        btnApply: string;
    };
    title?: string;
    type: ECampaignInfoType;
}

export interface ICampaignInfoActivateResult {
    campaignInquiryId: number;
}

